<template>
  <div class="block-9-container containerV2">
    <div>
      <h4 v-if="title" class="title">{{ title }}</h4>
    </div>
    <div class="block-9">
      <div class="media-column">
        <Media :images="images" cover />
      </div>
      <div class="text-column">
        <slot name="content" />
        <Link v-if="linkButton" :href="link">
          {{ linkButton }}
        </Link>
      </div>
    </div>
  </div>
</template>

<script>
import Media from "@/components/Media.vue";
import Link from "@/components/Link.vue";

export default {
  name: "HomepageBlock5",
  components: {
    Link,
    Media,
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    images: {
      type: Object,
      required: true,
    },
    linkButton: {
      type: String,
      default: null,
    },
    link: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.block-9-container {
  margin: 40px 0;
  @include respond-above(md) {
    margin: 60px 0;
  }
}
.block-9 {
  grid-row-gap: 20px;
  display: flex;
  flex-direction: column;
  @include respond-above(md) {
    align-items: center;
    column-gap: 40px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
}

.title {
  text-align: center;
  @include editorial-body(16px);
  font-style: italic;
  line-height: 150%;
  margin-bottom: 40px;

  @include respond-above(md) {
    margin-bottom: 60px;
  }
}
.text-column {
  margin: 0 auto;
  max-width: 347px;
  text-align: center;
  :deep(h2) {
    margin: 20px auto 16px;
    @include editorial-headline(24px);
  }
  :deep(h4) {
    @include editorial-headline(36px);
    line-height: 150%;
    margin-bottom: 20px;
    font-style: italic;
  }
  :deep(p) {
    @include editorial-body(14px);
    line-height: 150%;
    margin-bottom: 20px;
  }
}
</style>
